import * as React from "react";
const SvgGrayBars = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}) => <svg {...props} viewBox="0 0 320 140" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-labelledby={titleId} aria-describedby={descId}>{desc ? <desc id={descId}>{desc}</desc> : null}{title ? <title id={titleId}>{title}</title> : null}<rect width={320} height={18} rx={4} fill="#F5F5F5" /><rect y={22} width={240} height={14} rx={4} fill="#F9F9F9" /><rect y={52} width={320} height={18} rx={4} fill="#F5F5F5" /><rect y={74} width={240} height={14} rx={4} fill="#F9F9F9" /><rect y={104} width={320} height={18} rx={4} fill="#F5F5F5" /><rect y={126} width={240} height={14} rx={4} fill="#F9F9F9" /></svg>;
export default SvgGrayBars;